// Share only concurrent reads. Settled responses are never cached, and callers
// must include the current identity/company in the key.
export function createInflightRequests() {
  const requests = new Map();
  return (key, load) => {
    if (!requests.has(key)) {
      const request = Promise.resolve().then(load).finally(() => requests.delete(key));
      requests.set(key, request);
    }
    return requests.get(key);
  };
}
